import React, { useState } from 'react';
import axios from 'axios';

function OutdoorFilter() {
  const [maxNoise, setMaxNoise] = useState('');
  const [maxWeight, setMaxWeight] = useState('');
  const [refrigerant, setRefrigerant] = useState('');
  const [devices, setDevices] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [error, setError] = useState('');

  const handleFilter = async () => {
    try {
      let url = `http://127.0.0.1:5000/api/outdoor/filter?max_noise=${maxNoise}&max_weight=${maxWeight}`;
      if (refrigerant) {
        url += `&refrigerant=${refrigerant}`;
      }

      const response = await axios.get(url);
      setDevices(response.data);
    } catch (err) {
      console.error(err);
      setError('Błąd pobierania danych');
    }
  };

  const toggleSelectDevice = (device) => {
    if (selectedDevices.find(d => d.model === device.model)) {
      setSelectedDevices(selectedDevices.filter(d => d.model !== device.model));
    } else {
      if (selectedDevices.length < 3) {
        setSelectedDevices([...selectedDevices, device]);
      } else {
        alert('Możesz porównać maksymalnie 3 agregaty.');
      }
    }
  };

  return (
    <div>
      <h2>Filtruj agregaty (jednostki zewnętrzne)</h2>
      <div style={{ marginBottom: '1rem' }}>
        <label>
          Maksymalny hałas (dB):
          <input
            type="number"
            value={maxNoise}
            onChange={(e) => setMaxNoise(e.target.value)}
            style={{ marginLeft: '0.5rem' }}
          />
        </label>
        <label style={{ marginLeft: '1rem' }}>
          Maksymalna waga (kg):
          <input
            type="number"
            value={maxWeight}
            onChange={(e) => setMaxWeight(e.target.value)}
            style={{ marginLeft: '0.5rem' }}
          />
        </label>
        <label style={{ marginLeft: '1rem' }}>
          Czynnik chłodniczy:
          <input
            type="text"
            value={refrigerant}
            onChange={(e) => setRefrigerant(e.target.value)}
            placeholder="np. R32"
            style={{ marginLeft: '0.5rem' }}
          />
        </label>
        <button onClick={handleFilter} style={{ marginLeft: '1rem' }}>Filtruj</button>
      </div>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      <h3>Dostępne agregaty:</h3>
      <ul>
        {devices.map((device, index) => (
          <li key={index}>
            <input
              type="checkbox"
              checked={selectedDevices.some(d => d.model === device.model)}
              onChange={() => toggleSelectDevice(device)}
            />
            {device.manufacturer} {device.model} – Hałas: {device.noise_pressure} dB, Waga: {device.weight} kg, Czynnik: {device.refrigerant}
          </li>
        ))}
      </ul>

      {selectedDevices.length > 0 && (
        <div>
          <h3>Porównanie wybranych agregatów:</h3>
          <table border="1" cellPadding="8">
            <thead>
              <tr>
                <th>Model</th>
                <th>Producent</th>
                <th>Hałas (dB)</th>
                <th>Moc akustyczna (dB)</th>
                <th>Waga (kg)</th>
                <th>Wymiary</th>
                <th>Czynnik</th>
                <th>Ilość czynnika (kg)</th>
                <th>Przepływ powietrza (m³/h)</th>
                <th>SEER</th>
                <th>SCOP</th>
                <th>Pobór mocy chł. (kW)</th>
                <th>Pobór mocy grz. (kW)</th>
              </tr>
            </thead>
            <tbody>
              {selectedDevices.map((device, index) => (
                <tr key={index}>
                  <td>{device.model}</td>
                  <td>{device.manufacturer}</td>
                  <td>{device.noise_pressure}</td>
                  <td>{device.noise_power}</td>
                  <td>{device.weight}</td>
                  <td>{device.dimensions}</td>
                  <td>{device.refrigerant}</td>
                  <td>{device.refrigerant_charge}</td>
                  <td>{device.airflow}</td>
                  <td>{device.SEER}</td>
                  <td>{device.SCOP}</td>
                  <td>{device.power_input_cooling}</td>
                  <td>{device.power_input_heating}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default OutdoorFilter;
